import { Box, Divider, FormControl, Grid, IconButton, InputBase, MenuItem, Select, Typography, makeStyles } from '@material-ui/core'
import SearchBarWithFilters from 'components/search_with_filters'
import React, { useContext, useEffect, useMemo, useState } from 'react'

import useDebounce from 'lib/utils/debounce'
import MROButton from 'components/buttons'
import tableIcons, { options } from 'components/universal/table_attributes'
import MaterialTable from 'material-table'
import Warning from "assets/warning";
import CommercialIcon from 'assets/Commercial/Sales'
import TickIcon from 'assets/Commercial/Tick'
import { format24HrDateOnly, getColors, getOrganisationId } from 'lib/utils/common_utils'
import { Visibility } from '@material-ui/icons'
import moment from 'moment';
import { DatePicker, message } from "antd";
import PartSalesServices from 'lib/services/api/commercial/parts'
import { ToastMessageContext } from 'lib/contexts/message_context'
import RedCrossIcon from 'assets/Red remove icon.png'
import Tablefilters from 'components/Tablefilters'
import useGetFilterDetails from 'views/Commercial/Parts/FilterDetails'
import Overview from 'views/Commercial/Parts/Sales/Overview'
import StatusButton from 'views/Commercial/Parts/CoreExchange/StatusButton'
import ManageCoreDetails from 'views/Commercial/Parts/CoreExchange/SharedComponents/ManageCoreDetails'
import { downloadFileFromUrl } from 'lib/utils/helperFunctions'
import GetAppIcon from "@material-ui/icons/GetApp";
import DownloadCsv from 'components/DownloadCsv'
const { RangePicker } = DatePicker;



const useStyles = makeStyles((theme) => ({
    tableWrapper: {
        width: "95%",
        margin: "1% 3%",
    },



}))

export default function CoreExchanges(props) {

    const classes = useStyles();
    const { bases,
        accountStatus,
        coreCredit,
        coreDue,
        coreType,
        customerDetails,
        accountInvoices } = useGetFilterDetails()
    const [searchText, setSearchText] = useState("");
    const debounceVal = useDebounce(searchText)
    const [filterData, setFilterData] = useState({ line_customer_id: "", status: "Ready", core_type: "", due: "", invoiced: "" });
    const [action, setAction] = useState(null)
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [totalCount, setTotalCount] = useState(10)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const message = useContext(ToastMessageContext)
    const [currentSelection, setCurrentSelection] = useState({})
    const [coreFee, setCoreFee] = useState(null)
    const [tableData, setTableData] = useState([
        { id: "items", name: "Items", value: "0", color: "black", fontSize: "26px" },
        { id: "quote", name: "Quote", value: "0", color: "black", fontSize: "" },
        { id: "in_prog", name: "In Prog", value: "0", color: "amber", fontSize: "" },
        { id: "complete", name: "Complete", value: "0", color: "green", fontSize: "" },



    ])
    const [tableData1, setTableData1] = useState([
        { id: "quote", name: "Quote", value: "0", color: "black", fontSize: "" },
        { id: "live_job_credit", name: "Live Job Credit", value: "0", color: "amber", fontSize: "" },
        { id: "issued_credit_total", name: "Issued Credit", value: "0", color: "green", fontSize: "" },
    ])
    const [currencyName, setCurrencyName] = useState("")





    const filterOptions = [

        { name: "base_station_id", options: bases || [], placeholder: "Base (All)", },
        { name: "line_customer_id", options: customerDetails || [], placeholder: "Customer (All)", },
        { name: "status", options: accountStatus, placeholder: "", defaultValue: "" },
        { name: "core_type", options: coreType, placeholder: "Core Type (All)", defaultValue: "" },
        { name: "invoiced", options: coreCredit, placeholder: "Credited (All)", defaultValue: "" },




    ]



    // filters
    const handleFilterChange = (keyItem, value) => {

        setFilterData((prevState) => ({ ...prevState, [keyItem]: value }));
    };

    const handleDateChange = (value) => {
        if (value) {
            const fData = { ...filterData };
            fData["start_date"] = moment(value[0]).format("DD/MM/YYYY");
            fData["end_date"] = moment(value[1]).format("DD/MM/YYYY");
            setFilterData({ ...fData });
        } else {
            const fData = { ...filterData };
            filterData?.start_date && delete fData.start_date;
            filterData?.end_date && delete fData.end_date;
            setFilterData({ ...fData });
        }
    };

    const tableOptions = {
        ...options,
        page: page,
        total: totalCount,
        pageSize: pageSize,
        toolbar: false,

    };


    const renderStateIcon = (rowData) => {

        const Icon = {
            0: <CommercialIcon fill={getColors("red")} />,
            1: <CommercialIcon fill={getColors("amber")} />,
            2: <CommercialIcon fill={getColors("green")} />,
            3: <TickIcon fill={getColors("green")} />,
            4: <img src={RedCrossIcon} height={'20px'} />,
            5: <TickIcon fill={getColors("red")} />,
            6: <TickIcon fill={getColors("red")} />,


        }

        return Icon[rowData?.child_state]

    }





    const columns = [


        {
            title: "PS#",
            field: "ps",
            headerStyle: {

                textAlign: "left",
                paddingLeft: "15px"
            },
            cellStyle: {

                textAlign: "left",
                paddingLeft: "15px"
            }
        },
        {
            title: "State",
            field: "status",
            render: (rowData) => renderStateIcon(rowData)

        },

        {
            title: "Base",
            field: "base_station",


        },
        {
            title: "Date",
            field: "date",
            width: "10%",
            headerStyle: {
                width: "10%",
                textAlign: "left"
            },
            cellStyle: {
                width: "10%",
                textAlign: "left"
            },
            render: (rowData) => format24HrDateOnly(rowData?.date)
        },
        {
            title: "Customer",
            field: "customer",
            width: "15%",
            headerStyle: {
                width: "15%",
                textAlign: "left"
            },
            cellStyle: {
                width: "15%",
                textAlign: "left"
            }

        }, {
            title: "Part #",
            field: "part",
            width: "15%",
            headerStyle: {
                width: "15%",
                textAlign: "left"
            },
            cellStyle: {
                width: "15%",
                textAlign: "left"
            }

        },
        {
            title: "Type",
            field: "type",
            headerStyle: {

                textAlign: "left"
            },
            cellStyle: {

                textAlign: "left"
            },
            render: (rowData) => rowData?.type === 0 ? "Internal" : rowData?.type === 1 ? "External" : ""
        },
        {
            title: "QTY",
            field: "qty",
        },
        {
            title: "Core Value",
            field: "core_value",
        },
        {
            title: "Credit *",
            field: "credit",
        }, {
            title: "Currency",
            field: "currency",
        },
        {
            title: "Core Rtns",
            field: "core_rtn",
        }, {
            title: "Credited",
            field: "Credited",
            render: (rowData) => <span style={{ color: rowData?.credit_color ? getColors(rowData?.credit_color.toLowerCase()) : "", fontWeight: rowData?.credit_color ? 600 : "" }}>{rowData?.credited}</span>
        },

        {
            title: "Current State",
            field: "action",
            render: (rowData) =>


                <StatusButton status={rowData?.child_state} setAction={setAction} setCurrentSelection={setCurrentSelection} due_date={rowData?.due_date} rowDetails={rowData} />

        },

    ];
    const params = useMemo(() => {
        return {
            organisation_id: getOrganisationId(),
            search_keyword: debounceVal,
            ...filterData,
        };
    }, [filterData, debounceVal]);

    const getListingDetails = async () => {
        const newParams = {
            ...params,
            page: page + 1,
            count_per_page: pageSize,
        };
        try {
            setLoading(true)
            const response = await PartSalesServices.getAllCoreExchange(newParams)
            setCoreFee(response?.late_fee)
            if (response?.data) {
                setData(response.data)
                setTotalCount(response.total_count)
            }
            setLoading(false)
        }
        catch (error) {
            message.showToastMessage({ message: "Something went wrong. Try Again", variant: "error" });
            setLoading(false)
        }

    }
    let c_props = { ...currentSelection, late_fee: coreFee }

    useEffect(() => {
        getListingDetails();
    }, [params, page, pageSize]);

    const getOverViewDetails = async () => {
        try {

            const response = await PartSalesServices.getAccountsCoreHeader(params)
            setCurrencyName(response?.pending_items?.currency)
            let q_value = tableData.map((item) => {
                if (response.in_process.hasOwnProperty(item.id)) {
                    return {
                        ...item,
                        value: response.in_process[item.id].toString() // Convert value to string (optional)
                    };
                }
                return item;
            })

            setTableData(q_value)
            let s_value = tableData1.map((item) => {
                if (response.pending_items.hasOwnProperty(item.id)) {
                    return {
                        ...item,
                        value: response.pending_items[item.id].toString() // Convert value to string (optional)
                    };
                }
                return item;
            })

            setTableData1(s_value)

        }
        catch (error) {
            // message.showToastMessage({ message: "Something went wrong. Try Again", variant: "error" });
        }
    }

    useEffect(() => {
        getOverViewDetails()
    }, [params]);



    const downloadCsvHandler = async () => {
        setLoading("downloading");
        try {
            const newParams = {
                ...params,
                csv: true

            }

            const { file: fileUrl } = await PartSalesServices.getAllCoreExchange(newParams);


            // for downloading file automatically
            downloadFileFromUrl(fileUrl);
            message.showToastMessage({
                message: "File downloaded successfully",
                variant: "success",
            });
        } catch (error) {
            message.showToastMessage({
                message: "something went wrong!",
                variant: "error",
            });
        } finally {
            setLoading(null);
        }
    };






    return (
        <div className={classes.tableWrapper}>

            <SearchBarWithFilters handleSearch={setSearchText} searchText={searchText} padding={'4px 16px'} placeholder={'Search'}
            >
                {filterOptions && filterOptions.map(({ name, options, placeholder }) => (
                    <Tablefilters
                        key={name}
                        name={name}
                        options={options}
                        handleChange={handleFilterChange}
                        defaultValue={filterData[name]}
                        placeholder={placeholder}
                    />
                ))}

                <FormControl className="filter" >
                    <RangePicker
                        style={{ width: "291px" }}
                        format="DD/MM/YYYY"
                        // value={value}
                        onChange={handleDateChange}
                        allowClear={true}
                    />
                </FormControl>
                <Divider style={{ margin: "5px 0px 5px 0px" }} />
                <Typography color='primary' variant='subtitle2'>Overview</Typography>

                <Grid container spacing={2} style={{ padding: "15px 0px" }}>


                    <Overview title={"In Progress Cores"} data={tableData} gridItem={4} />
                    <Overview title={`In Progress Value (${currencyName})`} data={tableData1} gridItem={4} />


                </Grid>



            </SearchBarWithFilters>




            <Box mt={"20px"}>
                <MaterialTable
                    style={{ boxShadow: "0px 1px 3px #00000033" }}
                    icons={tableIcons}
                    title={""}
                    columns={columns}
                    data={data || []}
                    isLoading={loading}
                    options={tableOptions}

                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(pageSize) => {
                        setPageSize(pageSize);
                    }}
                    totalCount={totalCount}
                    page={page}

                />
                <DownloadCsv
                    startDate={filterData?.start_date}
                    endDate={filterData?.end_date}
                    isDateFilterPresent={true}
                    onDownload={downloadCsvHandler}

                />

                <div style={{ position: "absolute", marginTop: "-55px", marginLeft: "45px" }}>

                    <i>* Credit value based on current shipping, penalties and repair fees </i>
                </div>
            </Box>




            {action && action === "view" && <ManageCoreDetails handleClose={() => {
                setAction(null)
                getListingDetails()
            }} currentSelection={c_props} permission={props?.permission} isInvoiceOpen={true} />}






        </div>
    )
}
